import { BaseDto } from '@/shared/dtos/base-dto';

export class plan extends BaseDto {
    public nombre !: string;
    public nomenclatura !: string;
 } 
